import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import AtolLogoIcon from 'LuxKit/Icons/AtolLogoIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { memo } from 'react'
import { useIntl } from 'react-intl'

export type NavUspType = 'google' | 'atol'

interface Props {
  type: NavUspType
}

function NavBarUSP(props: Props) {
  const { type } = props
  const intl = useIntl()

  const atolLabel = intl.formatMessage({
    id: 'twyvRmnnslETd3sTskc7',
    defaultMessage: 'ATOL protected',
    description: 'Trust indicator showing ATOL financial protection in navigation bar',
  })
  const googleRating = '4.7/5'

  switch (type) {
    case 'atol':
      return <BodyTextBlock
        variant="small"
        startIcon={<AtolLogoIcon colour="normal-contrast" />}
        colour="light-foreground-alt"
      >
        {atolLabel}
      </BodyTextBlock>
    case 'google':
      return <Group direction="horizontal" gap={4} verticalAlign="center">
        <GoogleLongLogo height={rem(14)} />
        <BodyText variant="small">{googleRating}</BodyText>
      </Group>
    default:
      return null
  }
}

export default memo(NavBarUSP)
